import { CompanyTitledPage } from "../../TitledPage";
import DateInput from "../../../components/DateInput";
import { Grid, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import useOrderSummary from "./hooks/useOrderSummary";
import OrderSummaryTable from "./component/orderSummaryTable/OrderSummaryTable";
import OrderSummaryPaging from "./component/OrderSummaryPaging";

// 発注表タブの内容
function ProductTypeTab({tabPos, onChangeTabPos}) {

  const onChange = (_, v) => onChangeTabPos(v);

  return (
    <Tabs value={tabPos} onChange={onChange}>
      <Tab label="蔬菜" value={1} />
      <Tab label="果物" value={2} />
      <Tab label="スポット" value={3} />
    </Tabs>
  );
}

function OrderSummaryPage() {
  
  const orderSummary = useOrderSummary();

  const handleChangeShippingDate = (shippingDate) => {
    orderSummary.changeShippingDate(shippingDate);
  }

  const handleChangeTabPos = (tabPos) => {
    orderSummary.changeTabPosition(tabPos);
  }

  return (
    <CompanyTitledPage title="注文一覧">
      <Grid container spacing={2}>
        <Grid item>
          日付: 
            <DateInput
              value={orderSummary.shippingDate}
              setValue={handleChangeShippingDate}
            />          
        </Grid>
      </Grid>

      <Grid container spacing={2}  mb={2}>
        <Grid item xs>
          <ProductTypeTab
            tabPos={orderSummary.tabPos}
            onChangeTabPos={handleChangeTabPos}
          />
        </Grid>
      </Grid>

      <OrderSummaryTable orders={orderSummary.orders} />

      <OrderSummaryPaging
        page={orderSummary.page}
        maxPage={orderSummary.maxPage}
        changePage={orderSummary.movePage}
      />
      
    </CompanyTitledPage>
  );
}

export default OrderSummaryPage;